import { render, staticRenderFns } from "./product-introduce.vue?vue&type=template&id=7a1d27ee&scoped=true&"
import script from "./product-introduce.vue?vue&type=script&lang=js&"
export * from "./product-introduce.vue?vue&type=script&lang=js&"
import style0 from "./product-introduce.vue?vue&type=style&index=0&id=7a1d27ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1d27ee",
  null
  
)

export default component.exports